import apiClient, { fullApiClient } from './client';
import {
  ConsentHubConsentAndSubscriptionRequest,
  ConsentHubConsentResponse,
  ConsentHubSubscriptionRequest,
  ConsentHubConsentAndSubscriptionResponse,
} from './types';
import { AxiosResponse } from 'axios';

export const fetchPreferences = (hid: string): Promise<ConsentHubConsentAndSubscriptionResponse> =>
  apiClient.get('/consentsAndSubscriptions', { params: { hid } });

export const fetchSessionPreferences = async (): Promise<AxiosResponse<ConsentHubConsentAndSubscriptionResponse>> =>
  fullApiClient.get('/session/consentsAndSubscriptions');

export const sendPreferencesUpdate = (hid: string, subscriptions: ConsentHubSubscriptionRequest[]): Promise<void> =>
  apiClient.put(
    '/subscriptions',
    { subscriptions },
    {
      params: {
        hid,
        source: 'PREFERENCES_CENTER',
        action: 'UPDATE_PREFERENCES',
      },
    },
  );

export const sendGlobalUnsubscribe = (hid: string): Promise<void> =>
  apiClient.delete('/subscriptions/all', {
    params: { hid, source: 'PREFERENCES_CENTER', action: 'GLOBAL_UNSUBSCRIBE' },
  });

export const sendUnsubscribeList = (
  hid: string,
  keys: string,
  jobId: string | undefined = undefined,
): Promise<void> => {
  return apiClient.delete('/subscriptions', {
    params: {
      keys,
      hid,
      action: 'EMAIL_UNSUBSCRIBE_LINK',
      jobId,
      source: jobId != null ? 'SFMC_EMAIL' : undefined,
    },
  });
};

export const updateConsent = (request: ConsentHubConsentAndSubscriptionRequest): Promise<ConsentHubConsentResponse> =>
  apiClient.post('/consent', request);
